module.exports = __webpack_public_path__ + "1b48ad985223f8ca6060b353b1419145.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/4000_r_20.mp3
// module id = 415
// module chunks = 0